import React from "react";
import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Inbox, FileText, Package, MessageSquareQuote, LogOut, ExternalLink } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/leads", label: "Leads", icon: Inbox },
  { to: "/admin/blog", label: "Blog", icon: FileText },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/testimonials", label: "Testimonials", icon: MessageSquareQuote },
];

export function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen grid place-items-center bg-forest text-cream">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-[#f2eee4] flex" data-testid="admin-layout">
      <aside className="w-60 bg-forest text-cream flex flex-col fixed inset-y-0 left-0 z-20">
        <div className="p-5 border-b border-cream/10">
          <img src="/brand/logo-cream.png" alt="Leaf Alchemy" className="h-12 object-contain" />
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-gold text-ink" : "text-cream/80 hover:bg-cream/10"}`}>
              <n.icon size={18} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-cream/10 space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-cream/80 hover:bg-cream/10 transition-colors">
            <ExternalLink size={18} /> View Site
          </a>
          <button onClick={() => { logout(); nav("/admin/login"); }} data-testid="admin-logout" className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-cream/80 hover:bg-cream/10 transition-colors">
            <LogOut size={18} /> Logout
          </button>
        </div>
      </aside>
      <div className="flex-1 ml-60">
        <header className="h-16 bg-cream border-b border-forest/10 flex items-center justify-end px-8">
          <span className="text-sm text-forest/70">Signed in as <b className="text-forest">{user?.email}</b></span>
        </header>
        <main className="p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
